module.exports = __webpack_public_path__ + "static/media/yuce003.122e8664.jpg";